import axios from "axios";
import { resolveApiBaseUrl } from "./api-base-url";
import { applyCsrfHeader } from "./csrf";

export const toApiError = (error) => {
    if (error?.status !== undefined && error?.message !== undefined && Object.prototype.hasOwnProperty.call(error, "data")) {
        return error;
    }

    const status = error?.response?.status ?? 0;
    const data = error?.response?.data ?? null;
    const message = data?.message || data?.error || error?.message || "Unexpected Error";

    return {
        status,
        message,
        data,
        config: error?.config
    };
};

export const authApi = axios.create({
    baseURL: resolveApiBaseUrl(),
    withCredentials: true
});

authApi.interceptors.request.use((config) => applyCsrfHeader(config));

authApi.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(toApiError(error))
);
